import SafeImage from '@ui/SafeImage';
import { BlogDocument } from '@util/types/firestore/blog';

export function AuthorInfo({ blog }: { blog: BlogDocument }) {
  const date = new Date(blog.created);
  return (
    <div className="flex gap-[1.2rem]">
      <div className="h-[4.4rem] w-[4.4rem] rounded-full bg-brand-secondary">
        {blog?.author_photo && (
          <SafeImage
            className="rounded-full"
            alt={blog.author}
            src={blog.author_photo}
          />
        )}
      </div>
      <div className="grow">
        <p className="font-semibold">{blog.author}</p>
        <p className="text-[1.3rem]">
          {date.toLocaleDateString('en-us', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>
      </div>
    </div>
  );
}
